import { useEffect, useState } from 'react';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Hook that detects when the current user has been removed from a family
 * Shows a modal and refreshes the page
 */
export function useFamilyRemovalDetection() {
  const { user, fetchUser } = useAuthStore();
  const [showRemovedModal, setShowRemovedModal] = useState(false);
  const [previousFamilyId, setPreviousFamilyId] = useState<string | null>(null);

  useEffect(() => {
    if (!user) return;

    // Poll user data every 10 seconds to detect family removal
    const interval = setInterval(async () => {
      await fetchUser();
    }, 10000);

    return () => clearInterval(interval);
  }, [user, fetchUser]);

  useEffect(() => {
    // Detect when user had a familyId but now doesn't (was removed)
    if (previousFamilyId && user && !user.familyId) {
      setShowRemovedModal(true);
    }

    // Update previous familyId
    if (user?.familyId) {
      setPreviousFamilyId(user.familyId);
    }
  }, [user, previousFamilyId]);

  const handleAcknowledge = () => {
    setShowRemovedModal(false);
    // Full page refresh to reload all state and navigate to overview
    window.location.href = '/app';
  };

  return {
    showRemovedModal,
    handleAcknowledge,
  };
}
